import { useContext } from "react";
import { store } from "../store.js";

const useChangeMode = () => {
  const globalState = useContext(store);
  const { dispatch } = globalState;

  const changeMode = (isEditTool) => {
    
    var updatedToolData = JSON.parse(
      JSON.stringify(globalState.state.formData)
    );
    if (updatedToolData.isEditTool != isEditTool) {
      updatedToolData.isEditTool = isEditTool;
    
      dispatch({
        type: "UPDATE_FORM_WITOUT_HISTORIQUE",
        payload: updatedToolData,
      });
    }
  };

  return changeMode;
};

export default useChangeMode;
